module.exports = __webpack_public_path__ + "img/partner2.53bd49e9.png";